module.exports = __webpack_public_path__ + "static/27th-9ed7d15dd31300c38b5d473837d01988.png";